import React, { useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
    LinearProgress,
    Grid
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    UserList
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    root: {
    }
});

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getRoleAsync
    } = useContext(PageContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
        role
    } = state;

    const viewUserHandler = (user) => {
        navigateTo(NavRoutes.Admin.RoleUser, [roleId, user.userId]);
    }

    const removeUserHandler = (user) => {

    }

    const { roleId } = useParams();
    useEffect(() => {
        if(roleId) {
            getRoleAsync(parseInt(roleId));
        }
    }, [roleId]);

    useEffect(() => {
        setPageIsReady(role !== null)
    }, [role]);

    return (
        <>
            {pageIsReady ?
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            title={role.groupName}
                            subtitle="View and manage users in role"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <UserList
                            onViewUser={viewUserHandler}
                            onRemoveUser={removeUserHandler}
                        />
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const RoleUsersPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}